// ─── Camera ───────────────────────────────────────────
export const MIN_ZOOM = 0.15;
export const MAX_ZOOM = 3;
export const DEFAULT_ZOOM = 1;
export const ZOOM_SENSITIVITY = 0.002;

// ─── Physical planning scale ──────────────────────────
// Canonical footprints follow a schematic planning scale of roughly
// 20 px ≈ 1 ft (one GRID_SIZE cell per foot), so bays and parking read in
// realistic proportion to each other. This is a layout aid, NOT a
// surveyed or calibrated measurement.
//
// Defaults are VERTICAL (portrait). Orientation is derived from width vs
// height (never stored); Flip swaps the two. Changing these constants only
// affects NEW entities and the explicit "Apply Default Size" action —
// persisted geometry is never resized on load.

// ─── Work Bays ────────────────────────────────────────
// Standard lift / service bay ≈ 14 ft × 24 ft → 280 × 480.
// (History: 300×200 → 480×320 in Batch 10 for card readability; now set
// to real-world proportions.)
export const BAY_WIDTH = 280;   // ≈ 14 ft
export const BAY_HEIGHT = 480;  // ≈ 24 ft
// Space between generated bays: 40 px ≈ 2 ft — a GRID_SIZE multiple (the
// closest one to the previous 50 px), so generated positions stay on grid.
export const BAY_SPACING = 40;

// ─── Parking ──────────────────────────────────────────
// Typical 90° parking stall ≈ 9 ft × 18 ft → 180 × 360.
// Canonical size for ALL new parking — Facility Editor (single spaces,
// parking rows, wizard) and onboarding (generateParkingLayout). Existing
// spots keep their persisted size until an operator explicitly resizes /
// flips / applies the default and saves.
export const PARKING_WIDTH = 180;   // ≈ 9 ft
export const PARKING_HEIGHT = 360;  // ≈ 18 ft
// One grid space between adjacent spots, so row pitch stays grid-aligned.
export const PARKING_GAP = 20;

// ─── Layout ───────────────────────────────────────────
export const ROW_GAP = 100;
export const SECTION_GAP = 200;
export const GRID_SIZE = 20;

// ─── Fit-to-content ───────────────────────────────────
export const FIT_PADDING = 60;

// ─── Lockout reasons ─────────────────────────────────
export const LOCKOUT_REASONS = [
  'Lift Failure',
  'Bay Door Issue',
  'Electrical Problem',
  'Flooring Damage',
  'Equipment Maintenance',
  'Other',
] as const;
